import staticData from "@/public/data/flight/results.json";
import Flex from "@/shared/components/common/Flex";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import Typography from "@/shared/components/common/Typography";

interface RoundtripCardItemEmptyProps {
  direction: "departure" | "return";
}

export default function RoundtripCardItemEmpty({
  direction,
}: RoundtripCardItemEmptyProps) {
  const { selectDepartureFlightLabel, selectReturnFlightLabel } =
    staticData.roundTrip;
  return (
    <Flex
      alignItems={"center"}
      justifyContent={"between"}
      className="w-full p-3"
    >
      <Flex alignItems={"center"} gap={"3"}>
        <Flex.Item className="p-2 bg-grayColor rounded-sm">
          <PhosphorIcon
            name="Selection"
            size={26}
            className="!transform !scale-x-[-1] text-grayColor-foreground"
          />
        </Flex.Item>

        <Flex direction={"col"}>
          <Flex.Item>
            <Flex alignItems={"center"} gap={"2"}>
              <Flex.Item>
                <Typography variant={"body3"} fontWeight={"normal"}>
                  {direction === "departure"
                    ? selectDepartureFlightLabel
                    : selectReturnFlightLabel}
                </Typography>
              </Flex.Item>
            </Flex>
          </Flex.Item>
        </Flex>
      </Flex>
    </Flex>
  );
}
